import { createThirdwebClient } from 'thirdweb';
import { envConfig } from '@app/config';

export const client = createThirdwebClient({
  clientId: envConfig.thirdwebClientId!
});
